import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Forecasting/ForecastsList';

const ForecastsList = () => ((orgContainer(InnerComponent)));

export default ForecastsList;
